<template>
 
    <div class="report_wrap" ref="turtor">

      <div class="procard_btn" v-scroll-animate="'slide-itemgk'" v-show="false">
        <div
          class="procard_item"
          v-for="(item, index) in procardList"
          :key="index"
          :class="mouseOverIndex==index? 'active' : '' || activeIndex === index ? 'active' : ''"
          @click="changeIndex(index,item)"
          @mouseover="mouseOverIndex=index"
          @mouseout="mouseOverIndex = null"
        >
          <a class="activeA">{{ item.tit }} </a>
        </div>
        <!-- 移动端菜单 -->
        <el-row class="mobileGkmenu">
          <el-col :xs="12" v-for="(item, index) in procardList" :key="index">
            <div  :class="activeIndex === index ? 'mobileGkdiv active' : 'mobileGkdiv'" @click="changeIndex(index,item)">{{ item.tit }}</div> 
          </el-col>
        </el-row>
      </div>
    
      <div class="mainbody menus" v-scroll-animate="'slide-itemgk'" v-if="cengji == 2">
            <a href="/home"><i class="el-icon-s-home"></i></a> / <a @click="listVueFn(1)"> 信息公开</a> / 采购信息
            <span class="fontsizeCssy" >字体 【 <em @click="fontsize='big'">大</em> <em @click="fontsize='default'">中</em> <em @click="fontsize='small'">小</em> 】</span>

      </div>
        <el-row class="zhuan_column" type="flex">
         
            
            
        </el-row>
 
        <el-row style="width: 90%;margin:0 auto"  v-if="cengji == 1">
          <el-col :span="3" :xs="24">
            <div v-for="(item,index) in columnList" :key="item.id" v-scroll-animate="'fly-in-left5gy'" :class="(typeObj == index)? 'Lmenu active':'Lmenu'" >
              <a class="jianbian"   @click="changeTypeobj(index,item)">
                {{item}}
              </a>
            </div>
          </el-col>
          <el-col :span="21" :xs="24">
            <div class="Rcontent ">
             
              <ul style="min-height: 65vh;">
                <li v-for="item in columnListNow" :key="item.id"  v-scroll-animate="'fly-in-right5gy'">
                
                  <div class="Rtitle"> <a @click="goArticleDetail(item)">{{item.title}}</a> <span style="float: right;">{{ item.updateDate.substr(0,10) }}</span></div>
                </li>
                  
              </ul>
              <div class="change_page" >
                    <!-- 首页按钮 -->
                    <el-button 
                      class="pagination-btn first-last"
                      :disabled="currentPage === 1"
                      @click="handleFirstPage">
                      首页
                    </el-button>

                    <!-- 分页组件 -->
                    <el-pagination
                      layout="prev, pager, next"
                      :total="totalNum"
                      :page-size="pageSize"
                      :current-page="currentPage"
                      background
                      @current-change="pageChange"
                    />

                    <!-- 末页按钮 -->
                    <el-button 
                      class="pagination-btn first-last"
                      :disabled="currentPage >= totalPage"
                      @click="handleLastPage">
                      末页
                    </el-button>
                  </div>
            </div>
          </el-col>
        </el-row>
       
         
     

        <!-- 新闻动态三级页面(详情界面) -->
        <div class="articleDetailDiv" v-if="cengji == 2">
            <h1 v-scroll-animate="'fly-in-bottomgy'" class="fontSizeTitle">{{ articleDetail.title }}</h1>
            <p class="fontcssxy0 fontSizeTtme" v-scroll-animate="'fly-in-bottomgy'">发布时间：{{ articleDetail.createDate.substring(0,16) }}<span v-if="!!articleDetail.copyfrom" style="padding-left: 10px;padding-right:10px;">    来源：{{ articleDetail.copyfrom }}</span>   点击量：{{ articleDetail.hits }}</p>
            <div :class="this.fontsize=='big'?'contentcss0 contentcss0big':this.fontsize=='small'?'contentcss0 contentcss0small':'contentcss0'" v-blank-link v-html="articleDetail.content" v-scroll-animate="'fly-in-bottomgy'"></div>
            <!-- 新增上下篇导航 -->
            <div class="detail-pagination">
              <div class="pagination-bg">
                <div class="prev-article">
                  <template v-if="prevArticle">
                    <span class="pagination-label">上一篇：</span>
                    <a @click="goArticleDetail(prevArticle)" class="article-title">{{ prevArticle.title }}</a>
                  </template>
                  <template v-else>
                    <span class="pagination-label">上一篇：</span>
                    <span class="no-article">没有了</span>
                  </template>
                </div>
                <div class="next-article">
                  <template v-if="nextArticle">
                    <span class="pagination-label">下一篇：</span>
                    <a @click="goArticleDetail(nextArticle)" class="article-title">{{ nextArticle.title }}</a>
                  </template>
                  <template v-else>
                    <span class="pagination-label">下一篇：</span>
                    <span class="no-article">没有了</span>
                  </template>
                </div>
              </div>
            </div>
        </div>
    </div>

    

  </template>
  
  <script>
  import API from '@/api/index'

  import BScroll from '@better-scroll/core'
  import Pullup from '@better-scroll/pull-up'
  import MouseWheel from '@better-scroll/mouse-wheel'
  BScroll.use(Pullup)
  BScroll.use(MouseWheel)
  // import MediaList from '@/utils/mediaList.json'
  
  // cardId
  export default {
     props: {
      cardId: String,
    },
    data() {
      return {
         
        fontsize:'default',
        nowTab:null,
        articleDetail:[],
        currentPage:1,
        totalNum:0,
        pageSize:9,
        cengji:1, // 当前页面层级
        typeObj:0, // 新闻类型
       urlBase: process.env.VUE_APP_BASE_API,
        activeIndex: 0,
      
        columnList: [],
        columnListNow:[], // 二级页面列表
 
        activeIndex: 0,
        menuTxt:'',
        // cardId:'95eb0bc1de584139b2ff27c2e2154322',
        // 横向tab切换框菜单
        procardList: [
        ],
        mouseOverIndex:null,

       }
    },
    created() {
    
  },
    mounted() {
     
      this.getlist2()

    
    },
    computed: {
    totalPage() {
    return Math.ceil(this.totalNum / this.pageSize); // 确保使用组件内pageSize
  },
  pageRange() {
    return Array.from({length: this.totalPage}, (_, i) => i + 1)
  },
  prevArticle() {
      const index = this.columnListNow.findIndex(item => item.id === this.articleDetail.id);
      return index > 0 ? this.columnListNow[index - 1] : null;
    },
    nextArticle() {
      const index = this.columnListNow.findIndex(item => item.id === this.articleDetail.id);
      return index < this.columnListNow.length - 1 ? this.columnListNow[index + 1] : null;
    }
  },
    methods: {
         // 一级菜单切换方法
         changeIndex(index,item) {
        this.activeIndex = index
        this.menuTxt=this.procardList[index].tit
        this.cardId=item.id
        this.nowTab='货物'
        this.cengji=1
        
        this.getlist2('1')
      },

      async getlist2(obj) {
      try {
        // catId=338d62f89f6641c78f4ba196ac4500ac&pageNum=1&pageSize=10
        let objParams={
        catId:this.cardId,
        type:!obj?this.nowTab:null,
        pageNum:1,
        pageSize:10
      }
        const res = await API.cgList(objParams)
        this.columnListNow=res.data.procorementList 
        
        this.totalNum=res.data.totalNum
        this.totalPage=res.data.totalPage

        
        this.columnList=res.data.modules
        if(!!obj){
          this.typeObj=0

        }
        
       
        // this.nowTab=res.data.titleList[0].name
      
        console.log('获取成功', res.data.titleList)
      } catch (error) {
        console.error('获取失败', error)
      }
      },

       
      listVueFn(obj){
        if(obj != null){
          this.cengji=1
        }else{
          this.cengji--
        }
       
      },
      // 新闻动态往二级页面跳转，传参
      golist(obj){
        this.cengji=1
        this.typeObj=obj

       
        this.getlist()
      },
      // 新闻动态二级页面切换菜单
      changeTypeobj(obj,name){
        this.typeObj=obj
        this.nowTab= name
        this.currentPage=1
        this.getlist2()
      },

   

      // 企业文化一级页面获取列表接口方法
      async getlist(index) {
      try {
        // catId=95eb0bc1de584139b2ff27c2e2154322&&pageNum=1&pageSize=10
        let objParams={
        catId:this.cardId,
        pageNum:1,
        pageSize:10
      }
        const res = await API.cgYiji(objParams)
        this.procardList=res.data.titleList.map(item=>{
          let obj={
            tit: item.name,
            id:item.id
          }
          return  obj
        })
        if(!index){
          index=0
        }
        this.columnList=res.data.modules  // 左侧 二级tab 菜单数据 
        this.menuTxt=res.data.titleList[index].name  // 面包屑导航 一级tab选项
        this.cardId=res.data.titleList[index].id // 面包屑导航 一级tab选项id
        this.nowTab=res.data.modules[index] // 面包屑导航 二级tab选项
        
         
        this.columnListNow=res.data.titleList.length>0?res.data.titleList[index].procorementList : [] // 右侧 列表数据 
        
        this.columnListNow=res.data.titleList[index].procorementList || [] // 右侧 列表数据 
        this.totalNum=res.data.modules.length>0?res.data.modules[index].mapPage.totalNum : 0
        this.totalPage=res.data.modules.length>0?res.data.modules[index].mapPage.totalPage :0

        console.log('获取成功', res.data.titleList)
      } catch (error) {
        console.error('获取失败', error)
      }
      },

       // 列表页面 获取数据方法
      //  async getlist2() {
      //     try {
      //       let objParams={
      //         catId:this.columnList[this.typeObj].id,
      //         pageNum: this.currentPage,
      //         pageSize: this.pageSize 
      //       }
      //       const res = await API.getArticleById(objParams)
      //       this.columnListNow=res.data.artList 
            
      //       this.totalNum=res.data.totalNum
      //       this.totalPage=res.data.totalPage
            
      //       console.log('获取成功', res.data.artList)
      //     } catch (error) {
      //       console.error('获取失败', error)
      //     }
      // },
      
      pageChange(page) {
  // if (page < 1 || page > this.totalPage) return;
  this.currentPage = page;
  this.getlist2();
},
handleFirstPage() {
      if (this.currentPage !== 1) {
        this.pageChange(1)
      }
    },
    handleLastPage() {
      const last = this.totalPage
      if (this.currentPage !== last) {
        this.pageChange(last)
      }
    },
    
      // 新闻动态获取三级页面详情页
     async goArticleDetail(obj) {
      
      
      try {
         let objParams={
          proId:obj.id,
        }
        // const res = await API.cgDetail(objParams)
        // this.articleDetail=res.data.procorement
        // this.cengji=2
       
        // document.body.scrollTop = 0
        // document.documentElement.scrollTop = 0
        debugger
            window.open('/newsDetailHome?artId='+objParams.proId+'&zl=cgList', '_blank');
      } catch (error) {
        console.error('获取失败', error)
      }
      },
      handleNewsDetails(url) {
        // this.$router.push(`/news_detail/${id}`)
        window.open(url)
      },
      
     
    },
    watch: {
      // $route() {
      //   this.optionActive =
      //     this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
      // },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .detail-pagination {
  width: 80vw;
    margin: 2rem auto 0;
    padding: 1rem 0;
    border-top: 1px solid #eee;
  
    .pagination-bg {
      background: #f8f8f8;
      padding: 1.2rem;
      border-radius: 4px;
    }
  
    .prev-article, .next-article {
      line-height: 1.8;
      font-size: 0.95rem;
      
      + .next-article {
        margin-top: 0.8rem;
      }
    }
  
    .pagination-label {
      color: #999;
      margin-right: 0.5rem;
    }
  
    .article-title {
      color: #333;
      cursor: pointer;
      transition: color 0.3s;
  
      &:hover {
        color: #015293;
        text-decoration: underline;
      }
    }
  
    .no-article {
      color: #999;
    }
  }
  .pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 2rem 0;

  .page-nav {
   
    padding: 10px 24px; 
    min-width: 88px;    
    border: 1px solid #ddd;
    border-radius: 22px; 
    color: #666;
    background: transparent;
    transition: all 0.2s ease;
    height: 44px;     
    line-height: 22px;  
    
    &:hover:not(:disabled) {
      background: #f5f5f5;
      border-color: #ccc;
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .page-number {
    
    width: 44px;
    height: 44px;
    border: 1px solid #ddd;
    border-radius: 50%;
    background: transparent;
    color: #666;
    transition: all 0.2s ease;
    flex-shrink: 0;    

    &.active {
      background: #015293;
      border-color: #015293;
      color: white;
    }
    
    &:hover:not(.active) {
      background: #f5f5f5;
      border-color: #ccc;
    }
  }

  button {
    cursor: pointer;
    font-size: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    font-family: system-ui, -apple-system; 
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
  .report_wrap {
    padding-bottom: 8rem;
    .card_list {
      flex-wrap: wrap;
  
      .card_item {
        display: flex;
        margin-top: 1rem;
        padding: 20px;
        cursor: pointer;
        transition: all 0.5s;
  
        &:hover {
          box-shadow: 10px 10px 20px rgba($color: #000000, $alpha: 0.2);
          transform: scale(1.05);
        }
  
        .item_left {
          flex: 1;
  
          img {
            width: 90%;
            height: 100%;
            max-height: 350px;
            object-fit: cover;
            -webkit-user-drag: none;
          }
        }
  
        .item_right {
          flex: 1;
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
  
          h1 {
            color: #666;
            font-size: 28px;
  
            @media screen and (max-width: 768px) {
              font-size: 1rem;
            }
          }
  
          p {
            font-size: 13px;
  
            @media screen and (max-width: 768px) {
              &:nth-child(2) {
                display: none;
              }
  
              font-size: 13px;
            }
          }
        }
      }
    }
  }

  .zhuan_column {
    width: 90%;
    overflow: hidden;
    text-align: center;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: space-evenly;
  
    img {
      // width: 60%;
      width:auto;
      display: flexbox;
      height: 10rem !important;
    }
  
    .zhuan_item {
      @media screen and (max-width:768px) {
        &:nth-child(n+3) {
          margin-top: 10px;
        }
      }
  
      .zhuan_content {
        padding: 14px;
  
        @media screen and (max-width:768px) {
          pad: 10px;
        }
  
        h1 {
          min-height:2rem;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 1.1rem;
  
          @media screen and (max-width:768px) {
            min-height: 55px;
          }
        }
  
        .btn {
          background: #333333;
          float: right;
          color: #fff;
          margin-top: 20px;
          width: 80PX;
          height: 35PX;
          border-radius: 20PX;
  
          @media screen and (max-width:768px) {
            font-size: 12px;
          }
        }
  
        .details {
          color: #999;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
  
          @media screen and (max-width:768px) {
            font-size: 13px;
          }
        }
  
        .desc {
          color: #666;
          min-height: 60px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          margin: 10px 0;
  
          @media screen and (max-width:768px) {
            font-size: 13px;
          }
        }
      }
    }
  }
  .zhuan_column1{
    flex-wrap: wrap;
    justify-content:left;
  }
  
  .video_column {
    width: 100%;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: space-evenly;
  
    .video_item {
      .video_content {
        cursor: pointer;
        padding: 14px;
  
        h1 {
          color: #666;
          font-size: 0.9rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
  
          @media screen and (max-width:768px) {
            min-height: 65px;
          }
        }
      }
  
      img {
        width: 100%;
        min-height: 180px;
        cursor: pointer;
  
        @media screen and (max-width:768px) {
          min-height: 106px;
        }
      }
    }
  }
  
  .book_list_speial {
    padding-top: 16px;
    width: 70%;
    margin: 0 auto;
  }
  
  .scroll_btn2 {
    @media screen and (max-width:768px) {
      width: 280px;
      height: 35px;
      background: #fff !important;
      color: #151514 !important;
      border: solid 1px #333333 !important;
      font-size: 12px;
    }
  }
  .othernews3{
    background: #ffffff;
    display:flexbox;
    margin-top: 2rem;
    li{
        width: 100%;
        padding:10px;
        display: block;
        list-style: none;
        font-size: 1rem;
        color: #666666;
        line-height: 1.5rem;
        @media screen and (max-width:768px) {
           padding:1rem;
           font-size: 0.8rem;
        }
        span{
            font-size: 0.5rem;
            color: #999999;
            float: right;
        }
     }
   
  }
  .topH1{
    line-height: 5rem;
    text-align: left;
    width: 100%;
    padding-left: 3.5%;
    @media screen and (max-width:768px) {
      line-height: 1.5rem;
    }
    cursor: pointer;
    span{
      font-size: 0.5rem;
      margin-left: 1rem;
      color: #999999;
    }
  }
  .toptitle{
    width: 100%;
    height: 50px;
    cursor: pointer;
    background-color: aquamarine;
    border-radius: 0 50px 0 0;
    line-height: 50px; 
    font-size: 1.2rem;
    color: #ffffff;
    @media screen and (max-width:768px) {
        height: 2rem;
        border-radius: 0 2rem 0 0;
        line-height: 2rem;
        font-size: 1.2rem;
    }
  }
  .toptitle0{
    background: #e36833;
  }
  .toptitle1{
    margin-top: 60px;
    background: #015293;
  }
  .toptitle2{
    background: #eded5d;
  }
  .toptitle3{
    margin-top: 60px;
    background: #d266ae;
  }
  .menu001{
    margin: 0 auto;
    width: 90%;
    margin-bottom: 1rem;
    @media screen and (max-width:768px) {
      margin-bottom:0;
      }
    // background: #d266ae;
   
    .el-col{
      text-align: center;
      // border: 1px solid #2091d3;
      margin-bottom: 0.5rem;
      padding:1rem 0.5rem;
      font-size: 1rem;
      @media screen and (max-width:768px) {
        margin-bottom: 0;
        padding:0.5rem;
      }
    }
     
  }
  
  .menucss0 .el-col:nth-child(1){
    background: #015293;
    color: #ffffff;
  }
  .menucss1 .el-col:nth-child(2){
    background: #015293;
    color: #ffffff;
  }
  .menucss2 .el-col:nth-child(3){
    background: #015293;
    color: #ffffff;
  }
  .menucss3 .el-col:nth-child(4){
    background: #015293;
    color: #ffffff;
  }
  .menucss4 .el-col:nth-child(5){
    background: #015293;
    color: #ffffff;
  }
  .el-card__body{
    // position: relative;
    .goDetailcss0{
      // position: absolute;
      // top: 1px;
      // left: 17%;
      // transform: translateX(-50%);
      height:2.5rem;
      display:block;
      line-height: 2.5rem;
      background:none; 
      color: #ffffff;
      // padding:0.5rem 1rem;
    }
    .goDetailcss0:hover{
      background: #015293;
      color: #ffffff;

    }
  }
  .cssCol{
    cursor: pointer;
  }
  .change_page{
    width: 90%;
    margin: 0 auto;
    margin-top: 1rem;
  }

  .articleDetailDiv{
    width: 90vw;
    margin: 0 auto;
    border: 1px solid #e5e5e5;
    margin-bottom: 1rem;
    h1{
      width: 80%;
      margin:0 auto;
      margin-bottom: 1rem;
      border-bottom: 1px solid #999999;
      text-align: center;
      padding:1rem 0;
    }
    p{
      text-align: center;
    }
    div.contentcss0{
      margin: 0 auto;
      margin-top: 1rem;
      font-size: 0.8rem;
      line-height: 1rem;
      img{
        width: 60% !important;  //文章图片宽度
        height: auto !important;
      }
    }
    div.contentcss0 ::v-deep *{
      font-size: 1rem !important;
      line-height: 1.5rem !important;
      // text-align: justify !important;
    }
    div.contentcss0 ::v-deep p{
      text-indent: 2rem !important;
    }
  }
  .procard_btn {
    width: 90vw;
    margin:0 auto;
    margin-top: -1rem;

    display: flex;
    .mobileGkmenu{
      display:none;
    }
    .procard_item {
      flex: 1;
      height: 60px;
      // background: #f5f5f5;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        display:none;
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }
    .active {
      color: #fff;
      background: #015293;
      box-shadow: 0 4px 15px rgba(3, 210, 197, 0.3);

      font-weight: bold;
      &::before {
        // content: '▲';
        position: absolute;
        color: #015293;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
    @media screen and (max-width: 768px) {
      
        .mobileGkmenu{
          display:block;
          width:100%;
          // height:10rem;
          .mobileGkdiv{
            background:#e5e5e5;
            margin:0.25rem;
            line-height:2rem;
            text-align:center;
          }
          .active {
            color: #fff;
            background: #015293;
            font-weight: bold;
            &::before {
              content: '';
            }
          }
        }
    }
  }

  .mainbody{
  width: 90%;
  margin:0 auto;
  text-align: left;
 }
 

//  .menus{
//   padding:1rem;
//   padding-left: 0;
//   font-size:1rem;
//  }
 .Lmenu{
  margin-top:1rem;
  // padding:1rem;
  margin-bottom:0.5rem;
  font-size:1rem;
  background:#eee;
  text-align:center;
  a{
    display: block;
    width: 100%;
    padding:1rem;
    // background: #d38220;
    color:#666;
  }
  a:hover{
    // background:#2091d3;
    color:#ffffff;
  }
 }
 .active{
  color:#ffffff;
      // background: linear-gradient(to right, rgba(149, 216, 243, 0.5), #2091d3);
      // transition: background 0.5s ease;
      background: #015293;
    a{
      color:#ffffff;
   }
  }
  .Rcontent{
  display:flexbox;
  padding:1rem;
  padding-top:0;
  background:#ffffff;
  margin-left:3.5rem;
  @media screen and (max-width: 768px) {
    margin-left:0;
  }
    ul{
      li{
        list-style:none;
        // padding:1rem;
        line-height:1rem;
        border-bottom:1px solid #e5e5e5;
        display:flex;
        .Rtime{
          padding:1rem; 
          background:#e5e5e5;
          border-radius: 0.5rem;
          padding-bottom: 0.8rem;
          a{ 
            display: block;
            width:100%;
            text-align: center;
            font-size:1rem;
            font-weight:bold;
            color:#dab773;
            padding-top:0.5rem;
           
          }
          a.acss0{
            font-size: 1.2rem;
          }
        }
        .Rtitle{
          flex:80%;
          // padding:1.3rem;
          line-height: 3rem;
          padding-top:0.5rem;
          font-size:1rem;
          a{
            color:#333;
            
          }
          a:hover{
            color:#185aab;
          }
          p.pcss0{
            font-size: 0.8rem;
            width: 65vw !important;
            height: 4rem;
            background: #185aab;
            width: 100%;
            height: 4rem;
            background: #185aab;
            display: -webkit-box;
            -webkit-line-clamp: 2;     /* 限制显示行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            span{
              display: -webkit-box;
              -webkit-line-clamp: 2;     /* 限制显示行数 */
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      li.lastLi{
        border-bottom:none;
      }
    }
 }

 .articleDetailDiv {
    div.contentcss0big :not(.keep-style) {
        font-size: 1.1rem !important;
    }

    div.contentcss0small :not(.keep-style) {
        font-size: 0.9rem !important;
    }
}
  </style>